


































import { defineComponent, PropType, reactive } from '@vue/composition-api';
import { Mod } from '@c/landingpage/modpack/types';
import BaseAppModal from '@c/modal/BaseAppModal.vue';
import BaseModpackImage from '@c/landingpage/modpack/BaseModpackImage.vue';
import BaseModpackTagList from '@c/landingpage/modpack/BaseModpackTagList.vue';
import { useI18N } from '@a/composables/use-vue-i18n';
import { useRouter } from '@a/composables/use-router';
import RouteNames from '@a/router/routes';
import { useConfigurationApi } from '@a/plugins/configuration';
import { LandingPageItem } from '@a/store/landingpage/types';
import { useStore } from '@a/store';

export default defineComponent({
  emits: ['on-cancel-click'],
  name: 'BaseModpackModal',
  components: { BaseModpackTagList, BaseModpackImage, BaseAppModal },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Object as PropType<Mod>,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const i18n = useI18N();
    const { router } = useRouter();
    const config = useConfigurationApi();
    const { getters } = useStore();

    const state = reactive({
      tags: getters['game/modTags'],
    });

    const stepOneRoute = router.resolve({
      name: RouteNames.StepOneRoute,
      params: {
        ...router.currentRoute.params,
        languagePrefix: config.getRouteLanguage(),
        territoryPrefix: config.getRouteTerritory(),
        productKey: (config.data.pageData as LandingPageItem).key,
      },
      query: {
        resetBasket: '1',
        repoKey: props.value.key,
      },
    });

    return {
      state,
      stepOneRoute,
      emit,
      i18n,
    };
  },
});
